import React, { ForwardedRef, forwardRef } from 'react';
import Typography from '@lib/components/Typography/Typography';
import styles from './QuickCreationFieldsWrapper.module.scss';

export interface QuickCreationFieldsWrapperProps {
  children: React.ReactNode;
  title: string;
}

const QuickCreationFieldsWrapper = forwardRef(
  (
    props: QuickCreationFieldsWrapperProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const { children, title } = props;
    return (
      <div className={styles.wrapper} ref={ref}>
        <Typography variant="body" strong className={styles.title}>
          {title}
        </Typography>
        <div className={styles.fields}>{children}</div>
      </div>
    );
  },
);

export default QuickCreationFieldsWrapper;
